<template>
    <div class="page-table only-y mainDiv">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.opsiyon.liste.baslikH1")}}</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-table
                    :data="opsiyonList"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="baslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="olusturan"
                        label="Oluşturan"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">

                            <el-tooltip :content='$t("src.views.apps.urun.liste.urunduzenle")'
                                        :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        v-if="root || yetkiList.urunOpsiyonGuncelle"
                                        v-on:click="routeUrun('Opsiyon Düzenle',scope.row)"
                                        type="text"
                                        class="buttonEdit"
                                        icon="el-icon-edit">
                                </el-button>
                            </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.urun.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    class="buttonDel"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    type="text"
                                    icon="mdi mdi-pause mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
                :title='$t("src.views.apps.urun.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>'{{selection.baslik}}' {{$t('src.views.apps.urun.liste.uruntaslak')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="opsiyonKaldir(selection,selectionIndex,opsiyonList), deleteDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>

</template>

<script>
    import urunService from '../../../../WSProvider/UrunService'
    import notification from '../../../../notification'

    let base64 = require('base64_js');
    let userDataSortas = "";

    export default {
        name: "OpsiyonListesi",
        data() {
            return {
                pathh: urunService.path,
                opsiyonList: [],
                urunlarListTaslak: [],
                deleteDialogVisible: false,
                taslakDialogVisible: false,
                selection: '',
                selectionIndex: '',
                root : false,
                yetkiList: {
                    urunOpsiyonGuncelle: false,
                    urunKategoriDurumDegis: false,
                },
            }
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataSortas")) {
                userDataSortas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSortas"))));
                if (userDataSortas["tur"]) {
                    if (userDataSortas["tur"] === '1') {
                        self.root = true;
                        self.yetkiList.urunKategoriDurumDegis = true;
                        self.yetkiList.urunOpsiyonGuncelle = true;
                    }
                }
                if (userDataSortas["yetki"]) {
                    userDataSortas["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-482800':
                                self.yetkiList.urunOpsiyonGuncelle = true;
                                self.yetkiList.urunKategoriDurumDegis = true;
                                break;
                            case 'YK-462516':
                                self.yetkiList.urunKategoriDurumDegis = true;
                                break;
                        }
                    });
                }

            }

            this.getOpsiyonList();

        },
        methods: {
            routeUrun(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.uopsiyonKodu);
                }
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            getOpsiyonList() {
                let self = this;
                urunService.opsiyonList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            if (e.durum === '1') {
                                self.opsiyonList.push(e);
                            }
                        })

                    }
                })
            },
            opsiyonKaldir(selection, index, list) {
                urunService.opsiyonKaldir(selection.uopsiyonKodu).then((response) => {
                    if (response.status === 200) {
                        list.splice(index, 1);
                        notification.Status("success", this, "Opsiyon başarıyla kaldırıldı.")

                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }
    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>

<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }
</style>